import api from '../services/api';
import { IDentalTreatmentPayment } from '../shared/interfaces';

export const postDentalTreatmentPayment = async (
  payload: any,
): Promise<IDentalTreatmentPayment> => {
  const response = await api.post('/dental-treatments-payments', payload);
  return response.data;
};
